var map = {
	"./BNB.jpeg": "3376",
	"./BOT-icon.svg": "f151",
	"./BTCB.webp": "322d",
	"./BURGER-icon.svg": "1946",
	"./BUSD.png": "fc23",
	"./Blue-bull.svg": "b6f9",
	"./DEGO-icon.svg": "105e",
	"./ETH.webp": "0cb5",
	"./Green-bull.svg": "c2f4",
	"./HMDX.webp": "d7c5",
	"./MDX.webp": "be0b",
	"./Red-bull.svg": "6da9",
	"./USDT.webp": "a4ba",
	"./WBNB.png": "50ed",
	"./WeChat.png": "be86",
	"./adopt-egg-bg.svg": "f824",
	"./alpaca-beaten.png": "4680",
	"./alpaca.svg": "733a",
	"./apy.svg": "764e",
	"./arrow-down-white.svg": "e854",
	"./arrow-down.svg": "d995",
	"./bg-long.mp4": "4c97",
	"./bg.mp4": "4221",
	"./bnb.png": "d1d0",
	"./bottom-shadow.svg": "cbfb",
	"./bounce.png": "610c",
	"./breeding-heart.png": "8d51",
	"./breeding-heart.svg": "9b42",
	"./cancel.svg": "3c02",
	"./coin.svg": "bc21",
	"./copy.svg": "cf27",
	"./egg-1.svg": "adbf",
	"./egg-2.svg": "e12f",
	"./egg-3.svg": "6015",
	"./egg-4.svg": "ec68",
	"./egg-5.jpg": "bf2e",
	"./egg-6.svg": "3b30",
	"./egg-7.png": "190f",
	"./egg-8.svg": "6a7d",
	"./egg.svg": "25a8",
	"./eth.png": "d094",
	"./eth.svg": "f010",
	"./fees-collected.svg": "f6c9",
	"./fire-circle.svg": "5890",
	"./fire.svg": "f80d",
	"./gn.svg": "63cc",
	"./gold-egg.gif": "5bde",
	"./guide-hover.svg": "644b",
	"./guide.svg": "dcc37",
	"./home-activity-bg.png": "12d4",
	"./home-activity-bg.svg": "8965",
	"./home-bg.svg": "04c6",
	"./hunting.jpg": "cd93",
	"./info-white.svg": "0a56",
	"./info.svg": "9bbe",
	"./land1.jpg": "78a5",
	"./land2.jpg": "a00e",
	"./land3.jpg": "ec07",
	"./land4.jpg": "7542",
	"./lang.svg": "f59b",
	"./logo.svg": "155f",
	"./manage-stake.svg": "970b",
	"./mask.svg": "1f76",
	"./medium.svg": "e8a0",
	"./my-recycle.svg": "8c9c",
	"./nav-icon.svg": "aa67",
	"./new-bg.jpg": "2385",
	"./no-alpaca.svg": "68f5",
	"./order-color-icon.svg": "bd58",
	"./order-icon.svg": "4a0d",
	"./planting.jpg": "681a",
	"./pure-bg.jpg": "b212",
	"./recycle-alpaca.svg": "4c09",
	"./recycle.svg": "e10f",
	"./refer-popup.svg": "0ff9",
	"./referral.svg": "b630",
	"./right-arrow.svg": "8933",
	"./scarf.svg": "2b30",
	"./squad-earn.svg": "082d",
	"./token-presale.svg": "748d",
	"./total-price.svg": "6092",
	"./total-value-staked.svg": "3860",
	"./trans-success.svg": "7d28",
	"./treasureland.png": "61f0",
	"./wool.svg": "a547",
	"./your-deposit.svg": "46f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";